import Vue from 'vue'

export default Vue.component(
  'view-companion-animal',
  {
    data() {
      return {
        currentTab: window.location.hash?.substr(1) === 'contact' ? 'contact' : 'profile',
      }
    },
    methods: {
      changeTab(tab) {
        this.currentTab = tab === 'contact' ? 'contact' : 'profile'
        window.location.hash = this.currentTab
      }
    }
  }
)
